module.exports = __webpack_public_path__ + "img/success.75ec275a.svg";